import axios from "axios";
import { ElMessage } from "element-plus";

const api = axios.create({
  baseURL: import.meta.env.VITE_API_BASE_URL || "http://localhost:8000/api",
  timeout: 60000,
});

// 请求拦截器
api.interceptors.request.use(
  (config) => {
    // 登录和登出接口不需要 token
    const isAuthEndpoint =
      config.url &&
      (config.url.includes("/auth/login/") ||
        config.url.includes("/auth/logout/"));

    // 只有非认证接口才添加 token
    if (!isAuthEndpoint) {
      const token = localStorage.getItem("token");
      if (token) {
        config.headers.Authorization = `Token ${token}`;
      }
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// 响应拦截器
api.interceptors.response.use(
  (response) => {
    return response.data;
  },
  (error) => {
    if (error.response) {
      const { status, data } = error.response;
      if (status === 401) {
        localStorage.removeItem("token");
        window.location.href = "/login";
        ElMessage.error("登录已过期，请重新登录");
      } else {
        ElMessage.error(data?.error || data?.message || "请求失败");
      }
    } else {
      ElMessage.error("网络错误，请稍后重试");
    }
    return Promise.reject(error);
  }
);

export default api;
